import Bgimg from "./bg-img.png";
import Logoimg from "./company_logo.png";
import NavBarImg from "./navbar_img.png";
import AdminImg from "./UserProfile_Img.png";
import UserProfileImg from "./UserProfile_Img.png";
import loadingText from "./loading_text.png";
import loadingImg from "./loading_img.png";
const Img = {
    Bgimg,
    Logoimg,
    NavBarImg,
    AdminImg,
    loadingImg,
    loadingText,
    UserProfileImg,
}
export default Img;